import React, { useRef, useState } from "react";
import {
  StyledBooleanFilter,
  StyledBooleanFilterTooltip,
} from "./BooleanFilter-styled";
import { BooleanFilterProps } from "../Filter.types";

import "@esri/calcite-components/dist/components/calcite-button";
import { CalciteButton } from "@esri/calcite-components-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faPawSimple,
  faWheelchairMove,
  faCircleQuestion,
  faFamily,
} from "@fortawesome/pro-regular-svg-icons";

const BooleanFilter = ({
  onClick,
  isApplied,
  booleanFilterItem: {
    icon_calcite,
    icon_font_awesome,
    filter_label,
    show_label,
    has_tooltip,
    tooltip,
  },
}: BooleanFilterProps) => {
  const tooltipTriggerRef = useRef<HTMLSpanElement>(null);
  const [tooltipStyle, setTooltipStyle] = useState<React.CSSProperties>();
  const [tooltipPosition, setTooltipPosition] = useState<"above" | "below">("below");

  const positionTooltip = () => {
    const trigger = tooltipTriggerRef.current;
    if (!trigger) return;

    const bounds = trigger.getBoundingClientRect();
    const tooltip = trigger.querySelector<HTMLElement>(".tooltip-text");
    const tooltipHeight = tooltip?.getBoundingClientRect().height ?? 0;
    const shouldPositionAbove =
      window.innerHeight - bounds.bottom < tooltipHeight + 16 &&
      bounds.top >= tooltipHeight + 16;

    setTooltipStyle({
      left: `${bounds.left + bounds.width / 2}px`,
      top: `${shouldPositionAbove ? bounds.top - 16 : bounds.bottom + 16}px`,
      transform: shouldPositionAbove
        ? "translate(-50%, -100%)"
        : "translateX(-50%)",
    });
    setTooltipPosition(shouldPositionAbove ? "above" : "below");
  };

  let faIcon;
  if (icon_font_awesome === "paw") {
    faIcon = faPawSimple;
  }
  if (icon_font_awesome === "wheelchair") {
    faIcon = faWheelchairMove;
  }
  if (icon_font_awesome === "infoCircle") {
    faIcon = faCircleQuestion;
  }
  if (icon_font_awesome === "family") {
    faIcon = faFamily;
  }

  return (
    <StyledBooleanFilter key={`${filter_label}`} isChecked={isApplied}>
      <CalciteButton
        iconStart={isApplied ? "check-square" : "square"}
        iconEnd={icon_calcite ? icon_calcite : ""}
        appearance={isApplied ? "solid" : "outline"}
        color={isApplied ? "blue" : "neutral"}
        class={isApplied ? "" : "lib-neutral-button"}
        onClick={onClick}
        label={`${filter_label} ${isApplied ? "selected" : "unselected"}`}
      >
        {show_label ? filter_label : ""}
      </CalciteButton>
      {has_tooltip && faIcon ? (
        <StyledBooleanFilterTooltip
          ref={tooltipTriggerRef}
          aria-label={tooltip}
          onMouseEnter={positionTooltip}
        >
          <FontAwesomeIcon icon={faIcon} />
          <span className={`tooltip-text tooltip-${tooltipPosition}`} style={tooltipStyle}>
            {tooltip}
          </span>
        </StyledBooleanFilterTooltip>
      ) : (
        <></>
      )}
      {!has_tooltip && faIcon ? <FontAwesomeIcon icon={faIcon}></FontAwesomeIcon> : <></>}
    </StyledBooleanFilter>
  );
};

export default BooleanFilter;
